<template>
  <div class="sp-template">
    <div class="h-title">运力资源管理</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="渠道">
              <el-select v-model="conditions.productIds" placeholder="选择渠道">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商">
              <el-select v-model="conditions.supplierId">
                <el-option v-for="item in supplier" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运力">
              <el-input v-model="conditions.name" placeholder="请输入运力名称"></el-input>
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(70104)" type="primary" size="small" @click="capacitySearch">搜 索</el-button>
            <el-button v-if="in_configs(70104)" size="small" @click="reset">清 空</el-button>
          </div>
        </el-form>
      </div>
       <div class="table-operate__buttons">
        <el-tabs v-model="conditions.channelType" @tab-click="capacitySearch">
          <el-tab-pane label="空运" name="AIR_SHIPPING"></el-tab-pane>
          <el-tab-pane label="海运" name="SEA_SHIPPING"></el-tab-pane>
          <el-tab-pane label="铁运" name="RAILWAY_SHIPPING"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button v-if="in_configs(70101)" size="small" @click="addCapacity">添加运力</el-button>
        </div>
       </div>
      <el-table ref="multipleTable" :data="capacityData" stripe border style="width: 100%">
        <el-table-column prop="name" label="运力名称"></el-table-column>
        <el-table-column prop="clientName" label="供应商"></el-table-column>
        <el-table-column prop="channelType" label="渠道类型" :formatter="formatType" width="100"></el-table-column>
        <el-table-column prop="nameCn" label="渠道"></el-table-column>
        <el-table-column prop="volumeLimit" align="center" label="体积限制(m³)"></el-table-column>
        <el-table-column prop="weightLimit" align="center" label="重量限制(kg)"></el-table-column>
        <el-table-column prop="priority" align="center" label="优先级" :formatter="formatPriority"></el-table-column>
        <el-table-column prop="destination" align="center" label="目的机场/港"></el-table-column>
        <!-- <el-table-column prop="volumeWeightRatio" align="center" label="体积/重量"></el-table-column> -->
        <el-table-column prop="effectiveDate" align="center" label="有效时间" :formatter="formatDate"></el-table-column>
        <el-table-column prop="status" align="center" label="状态" :formatter="formatStatus"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="in_configs(70102)" @click="capacityEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="mini" v-if="in_configs(70103)" @click="capacityDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
      <el-dialog title="运力资源设置" class="fullwidth-form__dialog" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="rulesForm('capacityForm')" width="500px">
        <el-form :model="capacityForm" status-icon :rules="rules" ref="capacityForm" size="small" :label-width="formLabelWidth">
          <el-form-item label="运力名称"  prop="name">
            <el-input v-model="capacityForm.name" auto-complete="off" placeholder="运力名称"></el-input>
          </el-form-item>
          <el-form-item label="供应商"  prop="supplierId">
            <el-select v-model="capacityForm.supplierId" placeholder="请选择">
              <el-option v-for="item in supplier2" :key="item.id" :label="item.clientName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道类型"  prop="channelType">
            <el-select v-model="capacityForm.channelType" placeholder="请选择" @change="getChannel">
              <el-option v-for="item in channelTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择渠道"  prop="channelId">
            <el-select v-model="capacityForm.channelId" filterable>
              <el-option v-for="item in channelName" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="体积限制(m³)"  prop="volumeLimit">
            <el-input v-model.number="capacityForm.volumeLimit" auto-complete="off" placeholder="最大容量值"></el-input>
          </el-form-item>
          <el-form-item label="重量限制(kg)"  prop="weightLimit">
            <el-input v-model.number="capacityForm.weightLimit" auto-complete="off" placeholder="最重量量值"></el-input>
          </el-form-item>
          <el-form-item label="优先级"  prop="priority">
            <el-select v-model.lazy="capacityForm.priority" placeholder="请选择优先级">
              <el-option v-for="item in priority" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="目的机场" v-if="isAirport"  prop="destination">
            <el-input v-model="capacityForm.destination" auto-complete="off" placeholder="目的机场"></el-input>
          </el-form-item>
          <el-form-item label="目的港" v-if="isHarbor"  prop="destination">
            <el-input v-model="capacityForm.destination" auto-complete="off" placeholder="目的港"></el-input>
          </el-form-item>
          <el-form-item v-if="false" label="体积/重量"  prop="volumeWeightRatio">
            <el-input v-model="capacityForm.volumeWeightRatio" auto-complete="off" placeholder="体积/重量比例"></el-input>
          </el-form-item>
          <el-form-item label="有效时间类型"  prop="effectiveType">
            <el-select v-model.lazy="capacityForm.effectiveType" placeholder="请选择类型" @change="effectiveDate">
              <el-option label="每周" value="WEEK"></el-option>
              <el-option label="每月" value="MONTH"></el-option>
              <el-option label="每天" value="EVERYDAY"></el-option>
              <el-option label="临时" value="TEMPORARY"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="每周有效时间" v-if="isWeek"  prop="week">
            <el-select v-model="capacityForm.week" multiple placeholder="请选择时间">
              <el-option v-for=" item in weekDay" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="每月有效时间" v-if="isMonth"  prop="month">
            <el-select v-model="capacityForm.month" multiple placeholder="请选择时间">
              <el-option v-for=" item in monthDate" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="临时有效时间" v-if="isTemporary"  prop="temporary">
            <el-date-picker v-model="capacityForm.temporary" :picker-options="usageDateOptions" :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="状态" >
            <el-radio v-model="capacityForm.status" label="1">启用</el-radio>
            <el-radio v-model="capacityForm.status" label="0">停用</el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('capacityForm')">取 消</el-button>
          <el-button size="small" type="primary" @click="submitCapacityForm('capacityForm')">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    var checkCapacityName = (rule, value, callback) => {
      if (this.flag) {
        if (value == this.capacityData.name) {
          callback();
          return;
        }
      }

      this.$request1({
        method: 'GET',
        url: '/capacity/check',
        params: { name: value }
      })
        .then(response => {
          console.log(response.data.success);
          if (response.data.success) {
            callback(new Error("运力名称已存在"));
          } else {
            callback();
          }
        })
        .catch(error => {
          console.log(error);
        });
    };
    return {
      conditions: {
        id: "",
        channelType: "AIR_SHIPPING",
        supplierId: "",
        productIds: "",
        name: ""
      },
      capacity: [],
      supplier: [],
      supplier2: [],
      channelTypes: [
        { value: "SEA_SHIPPING", label: "海运" },
        { value: "AIR_SHIPPING", label: "空运" },
        { value: "RAILWAY_SHIPPING", label: "铁运" }
      ],
      channelName: [],
      channels: [],
      priority: [
        {
          label: "体积优先",
          value: "VOLUME"
        },
        {
          label: "重量优先",
          value: "WEIGHT"
        }
      ],
      capacityData: [],
      capacityForm: {
        id: "",
        name: "",
        supplierId: "",
        channelType: "",
        channelId: "",
        volumeLimit: "",
        weightLimit: "",
        volumeRatio: 0,
        weightRatio: 0,
        volumeWeightRatio: "",
        priority: "",
        effectiveType: "",
        week: [],
        month: [],
        everyDay: [],
        temporary: "",
        status: "1"
      },
      weekDay: [
        {
          id: 1,
          label: "周一"
        },
        {
          id: 2,
          label: "周二"
        },
        {
          id: 3,
          label: "周三"
        },
        {
          id: 4,
          label: "周四"
        },
        {
          id: 5,
          label: "周五"
        },
        {
          id: 6,
          label: "周六"
        },
        {
          id: 7,
          label: "周天"
        }
      ],
      monthDate: [
        {
          id: 1,
          label: 1
        },
        {
          id: 2,
          label: 2
        },
        {
          id: 3,
          label: 3
        },
        {
          id: 4,
          label: 4
        },
        {
          id: 5,
          label: 5
        },
        {
          id: 6,
          label: 6
        },
        {
          id: 7,
          label: 7
        },
        {
          id: 8,
          label: 8
        },
        {
          id: 9,
          label: 9
        },
        {
          id: 10,
          label: 10
        },
        {
          id: 11,
          label: 11
        },
        {
          id: 12,
          label: 12
        },
        {
          id: 13,
          label: 13
        },
        {
          id: 14,
          label: 14
        },
        {
          id: 15,
          label: 15
        },
        {
          id: 16,
          label: 16
        },
        {
          id: 17,
          label: 17
        },
        {
          id: 18,
          label: 18
        },
        {
          id: 19,
          lable: 19
        },
        {
          id: 20,
          label: 20
        },
        {
          id: 21,
          label: 21
        },
        {
          id: 22,
          label: 22
        },
        {
          id: 23,
          label: 23
        },
        {
          id: 24,
          label: 24
        },
        {
          id: 25,
          label: 25
        },
        {
          id: 26,
          label: 26
        },
        {
          id: 27,
          label: 27
        },
        {
          id: 28,
          label: 28
        },
        {
          id: 29,
          label: 29
        },
        {
          id: 30,
          label: 30
        },
        {
          id: 31,
          label: 31
        }
      ],
      usageDateOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 3600 * 1000 * 24;
        }
      },
      rules: {
        name: [
          { required: true, message: "请输入运力名称", trigger: "blur" },
          { validator: checkCapacityName, trigger: "blur" }
        ],
        supplierId: [
          { required: true, message: "请选择供应商", trigger: "change" }
        ],
        channelType: [
          { required: true, message: "请选择渠道类型", trigger: "change" }
        ],
        channelId: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        volumeLimit: [
          { required: true, message: "请输入体积限制", trigger: "blur" },
          {
            pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输入数字值，最多保留两位小数",
            trigger: "blur"
          }
        ],
        weightLimit: [
          { required: true, message: "请输入重量限制", trigger: "blur" },
          {
            pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输入数字值，最多保留两位小数",
            trigger: "blur"
          }
        ],
        volumeWeightRatio: [
          { required: true, message: "请输入体积/体重", trigger: "blur" },
          {
            pattern: /(^([0-9]+)?:([0-9]+)?$)|(^([0-9]+)?：([0-9]+)?$)/,
            message: "输入格式输入有误(xx:xx)",
            trigger: "blur"
          }
        ],
        priority: [
          { required: true, message: "请选择有优先级", trigger: "change" }
        ],
        destination: [
          { required: true, message: "请输入目的地", trigger: "blur" }
        ],
        effectiveType: [
          { required: true, message: "请选择有效时间类型", trigger: "change" }
        ],
        week: [
          { required: true, message: "请选择有效时间", trigger: "change" }
        ],
        month: [
          { required: true, message: "请选择有效时间", trigger: "change" }
        ],
        temporary: [
          { required: true, message: "请选择有效时间", trigger: "change" }
        ]
      },
      ratioArr: [],
      currentPage: 1, //当前页
      total: 0, //总条数
      pageSize: 10, //当前显示条数
      pageSizes: [10, 20, 50, 100], //显示条数
      dialogFormVisible: false,
      isWeek: false,
      isMonth: false,
      isTemporary: false,
      isAirport: false,
      isHarbor: false,
      flag: false,
      formLabelWidth: "120px"
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.loadCapacity(this.conditions, this.currentPage, this.pageSize);
      this.loadSupplierName();
      this.loadChannels();
    }, 900);
  },
  computed: {},
  methods: {
    //加载运力资源信息
    loadCapacity(conditions, currentPage, pageSize) {
      this.$request1({
        method: 'GET',
        url: '/capacity/load',
        params: {
          id: conditions.id,
          name: conditions.name,
          channelType: conditions.channelType,
          supplierId: conditions.supplierId,
          channelId: conditions.productIds,
          currentPage: currentPage,
          pageSize: pageSize
        }
      })
        .then(response => {
          this.capacityData = response.data.capacityList;
          this.supplier2 = response.data.supplierList;
          this.total = response.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取渠道
    loadChannels() {
      this.$request1({
        method: 'GET',
        url: '/system/channel/all'
      })
        .then(response => {
          this.channels = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //加载所有供应商名称
    loadSupplierName() {
      this.$request1({
        method: 'GET',
        url: '/supplier'
      })
        .then(response => {
          this.supplier = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //选择渠道类型获得对应的渠道
    getChannel() {
      this.capacityForm.channelId = "";
      this.channelName = [];
      if (this.capacityForm.channelType == "AIR_SHIPPING") {
        this.isAirport = true;
        this.isHarbor = false;
      } else {
        this.isAirport = false;
        this.isHarbor = true;
      }
      this.$request1({
        method: 'GET',
        url: '/system/channel/type',
        params: {
          channelType: this.capacityForm.channelType
        }
      })
        .then(response => {
          this.channelName = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatDate(data) {
      let week = "";
      let month = "";
      let temporary = "";
      if (data.effectiveType == "WEEK") {
        let weeks = eval(data.effectiveDate).sort();

        for (var i = 0; i < weeks.length; i++) {
          if (weeks[i] == 1) {
            week += "周一 ";
          } else if (weeks[i] == 2) {
            week += "周二 ";
          } else if (weeks[i] == 3) {
            week += "周三 ";
          } else if (weeks[i] == 4) {
            week += "周四 ";
          } else if (weeks[i] == 5) {
            week += "周五 ";
          } else if (weeks[i] == 6) {
            week += "周六 ";
          } else if (weeks[i] == 7) {
            week += "周天 ";
          }
        }
        return "每周：" + week;
      } else if (data.effectiveType == "MONTH") {
        month = eval(data.effectiveDate).sort();
        return "每月：" + month + " 号";
      } else if (data.effectiveType == "EVERYDAY") {
        return "每天";
      } else if (data.effectiveType == "TEMPORARY") {
        return data.effectiveDate;
      }
    },
    formatType(data) {
      switch (data.channelType) {
        case "SEA_SHIPPING":
          return "海运";
          break;
        case "AIR_SHIPPING":
          return "空运";
          break;
        case "RAILWAY_SHIPPING":
          return "铁运";
          break;
      }
    },
    formatPriority(data) {
      switch (data.priority) {
        case "VOLUME":
          return "体积优先";
          break;
        case "WEIGHT":
          return "重量优先";
          break;
      }
    },
    //转换状态显示：1：启用 0：停用
    formatStatus(data) {
      return data.status == "1" ? "启用" : "停用";
    },
    //搜索
    capacitySearch() {
      this.loadCapacity(this.conditions, this.currentPage, this.pageSize);
    },
    reset() {
      this.conditions = {
        id: "",
        channelType: "AIR_SHIPPING",
        supplierId: "",
        productIds: "",
        name: ""
      }
      this.capacitySearch()
    },
    //编辑
    capacityEdit(index, row) {
      this.dialogFormVisible = true;
      this.flag = true;
      this.capacityForm.id = row.id;
      this.capacityForm.name = row.name;
      this.capacityData.name = row.name;
      this.capacityForm.supplierId = row.supplierId;
      this.capacityForm.channelType = row.channelType;
      this.capacityForm.channelId = row.channelId;
      this.capacityForm.volumeLimit = row.volumeLimit;
      this.capacityForm.weightLimit = row.weightLimit;
      this.capacityForm.destination = row.destination;
      this.capacityForm.volumeWeightRatio = row.volumeWeightRatio;
      this.capacityForm.priority = row.priority;
      this.capacityForm.effectiveType = row.effectiveType;
      this.capacityForm.status = row.status.toString();
      this.status = 1;
      if (row.effectiveType == "WEEK") {
        this.isWeek = true;
        this.isMonth = false;
        this.isTemporary = false;
        this.capacityForm.week = eval(row.effectiveDate);
        this.capacityForm.month = [];
        this.capacityForm.temporary = "";
      } else if (row.effectiveType == "MONTH") {
        this.isMonth = true;
        this.isTemporary = false;
        this.isWeek = false;
        this.capacityForm.week = [];
        this.capacityForm.month = eval(row.effectiveDate);
        this.capacityForm.temporary = "";
      } else if (row.effectiveType == "EVERYDAY") {
        this.isMonth = false;
        this.isTemporary = false;
        this.isWeek = false;
        this.capacityForm.week = [];
        this.capacityForm.month = [];
        this.capacityForm.everyDay = eval(row.effectiveDate);
        this.capacityForm.temporary = "";
      } else {
        this.isTemporary = true;
        this.isWeek = false;
        this.isMonth = false;
        this.capacityForm.week = [];
        this.capacityForm.month = [];
        this.capacityForm.temporary = row.effectiveDate;
      }

      if (row.channelType == "AIR_SHIPPING") {
        this.isAirport = true;
        this.isHarbor = false;
      } else {
        this.isAirport = false;
        this.isHarbor = true;
      }

      this.$request1({
        method: 'GET',
        url: '/system/channel/type',
        params: {
          channelType: row.channelType
        }
      })
        .then(response => {
          this.channelName = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addCapacity() {
      this.dialogFormVisible = true;
      this.channel = [];
      this.flag = false;
      this.status = 0;
    },
    //计算体积和重量的百分比
    // ratioArray() {
    //   let num = this.capacityForm.volumeWeightRatio.indexOf("：");
    //   if (num != -1) {
    //     this.ratioArr = this.capacityForm.volumeWeightRatio.split("：");
    //   } else {
    //     this.ratioArr = this.capacityForm.volumeWeightRatio.split(":");
    //   }
    //   let sum = parseInt(this.ratioArr[0]) + parseInt(this.ratioArr[1]);
    //   this.capacityForm.volumeRatio = (
    //     parseInt(this.ratioArr[0]) / sum
    //   ).toFixed(2);
    //   this.capacityForm.weightRatio = (
    //     parseInt(this.ratioArr[1]) / sum
    //   ).toFixed(2);
    // },
    effectiveDate() {
      if (this.capacityForm.effectiveType == "WEEK") {
        this.isWeek = true;
        this.isMonth = false;
        this.isTemporary = false;
        this.capacityForm.month = [];
        this.capacityForm.everyDay = [];
        this.capacityForm.temporary = "";
      } else if (this.capacityForm.effectiveType == "MONTH") {
        this.isMonth = true;
        this.isTemporary = false;
        this.isWeek = false;
        this.capacityForm.week = [];
        this.capacityForm.everyDay = [];
        this.capacityForm.temporary = "";
      } else if (this.capacityForm.effectiveType == "EVERYDAY") {
        this.isMonth = false;
        this.isTemporary = false;
        this.isWeek = false;
        this.capacityForm.week = [];
        this.capacityForm.month = [];
        this.capacityForm.temporary = "";
        let everyDay = [];
        this.monthDate.forEach((item, index) => {
          everyDay.push(item.id);
        });
        this.capacityForm.everyDay = everyDay;
      } else {
        this.isTemporary = true;
        this.isWeek = false;
        this.isMonth = false;
        this.capacityForm.week = [];
        this.capacityForm.month = [];
        this.capacityForm.everyDay = [];
      }
    },
    //添加/修改运力资源
    submitCapacityForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.capacityForm.week == "") {
            this.capacityForm.week = null;
          }
          if (this.capacityForm.month == "") {
            this.capacityForm.month = null;
          }
          if (this.capacityForm.temporary == "") {
            this.capacityForm.temporary = null;
          }
          if (this.capacityForm.everyDay == "") {
            this.capacityForm.everyDay = null;
          }

          if (this.capacityForm.effectiveType == "WEEK") {
            this.capacityForm["effectiveDate"] = this.capacityForm.week;
          } else if (this.capacityForm.effectiveType == "MONTH") {
            this.capacityForm["effectiveDate"] = this.capacityForm.month;
          } else if (this.capacityForm.effectiveType == "EVERYDAY") {
            this.capacityForm["effectiveDate"] = this.capacityForm.everyDay;
          }
          // this.ratioArray();
          this.$request1({
            method: 'post',
            url: '/capacity/save',
            data: JSON.stringify(this.capacityForm),
            headers: { "Content-Type": "application/json" },
            xhrFields: {
              withCredentials: true
            }
          })
            .then(response => {
              this.dialogFormVisible = false;
              this.$refs[formName].resetFields();
              this.emptyForm();
              this.success();
              this.loadCapacity(
                this.conditions,
                this.currentPage,
                this.pageSize
              );
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
          this.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除
    capacityDelete(index, row) {
      let self = this;
      this.$confirm("此操作将永久删除该运力信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(_ => {
          this.$request1({
            method: 'post',
            url: '/capacity/delete',
            params: { id: row.id }
          })
            .then(response => {
              self.capacityData.splice(index, 1);
              this.$message({
                message: "删除成功",
                type: "success",
                center: true,
                duration: 1500
              });
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
        })
        .catch(_ => {});
    },
    //清空表单数据
    emptyForm() {
      this.channelName = [];
      this.capacityForm.id = "";
      this.capacityForm.name = "";
      this.capacityForm.supplierId = "";
      this.capacityForm.channelType = "";
      this.capacityForm.channelId = "";
      this.capacityForm.volumeLimit = "";
      this.capacityForm.weightLimit = "";
      this.capacityForm.volumeWeightRatio = "";
      this.capacityForm.priority = "";
      this.capacityForm.effectiveType = "";
      this.capacityForm.week = "";
      this.capacityForm.month = "";
      this.capacityForm.everyDay = "";
      this.capacityForm.temporary = "";
      this.capacityForm.status = "1";
      this.dialogFormVisible = false;
      this.isWeek = false;
      this.isMonth = false;
      this.isTemporary = false;
    },
    //清除验证
    close(formRule) {
      this.$refs[formRule].clearValidate();
      this.emptyForm();
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    //操作成功
    success() {
      if (this.status == 1) {
        this.$message({
          message: "修改成功",
          type: "success",
          center: true,
          duration: 1500
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          center: true,
          duration: 1500
        });
      }
    },
    //分页
    handleSizeChange(pageSizes) {
      this.pageSize = pageSizes;
      this.loadCapacity(this.conditions, this.currentPage, pageSizes);
    },
    handleCurrentChange(currentPage) {
      this.loadCapacity(this.conditions, currentPage, this.pageSize);
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/capacity.vue